import { render, staticRenderFns } from "./LeftBaseView.vue?vue&type=template&id=397dd81a&"
import script from "./LeftBaseView.vue?vue&type=script&lang=js&"
export * from "./LeftBaseView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports